var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPurseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6462_18401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.25 22.1248C44.25 25.9408 44.0471 29.6455 43.674 33.18C43.3009 36.7146 40.6696 39.1888 37.3053 39.5488C33.7773 39.9284 30.0725 40.1248 26.25 40.1248C22.4275 40.1248 18.7293 39.9218 15.1947 39.5488C11.6602 39.1757 9.186 36.5444 8.826 33.18C8.44636 29.652 8.25 25.9473 8.25 22.1248C8.25 18.3022 8.45291 14.604 8.826 11.0695C9.19909 7.53494 11.8304 5.06076 15.1947 4.70076C18.7227 4.32112 22.4275 4.12476 26.25 4.12476C30.0725 4.12476 33.7707 4.32766 37.3053 4.70076C40.8398 5.07385 43.314 7.70512 43.674 11.0695C44.0536 14.5975 44.25 18.3022 44.25 22.1248Z",
    fill: "url(#paint0_radial_6462_18401)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.9775 25.1848C32.7975 27.1873 31.35 28.4998 29.25 28.4998H22.5C20.43 28.4998 18.75 26.8198 18.75 24.7498V19.4998C18.75 17.4598 19.98 16.0348 21.8925 15.7948C22.0875 15.7648 22.29 15.7498 22.5 15.7498H29.25C29.445 15.7498 29.6325 15.7573 29.8125 15.7873C31.605 15.9973 32.82 17.2498 32.9775 19.0648C33 19.2823 32.82 19.4623 32.6025 19.4623H31.44C30.72 19.4623 30.0525 19.7398 29.5725 20.2348C29.0025 20.7898 28.7175 21.5698 28.785 22.3498C28.905 23.7148 30.105 24.7873 31.53 24.7873H32.6025C32.82 24.7873 33 24.9673 32.9775 25.1848Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7531 21.3523V22.8973C33.7531 23.3098 33.4231 23.6473 33.0031 23.6623H31.5331C30.7231 23.6623 29.9806 23.0698 29.9131 22.2598C29.8681 21.7873 30.0481 21.3448 30.3631 21.0373C30.6406 20.7523 31.0231 20.5873 31.4431 20.5873H33.0031C33.4231 20.6023 33.7531 20.9398 33.7531 21.3523Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6462_18401",
    x: 0.000513077,
    y: 0.0000123978,
    width: 52.499,
    height: 52.499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.12474
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.12474
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.505882 0 0 0 0 0.101961 0 0 0 0 0.905882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6462_18401"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6462_18401",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_6462_18401",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.25 47.3794) rotate(-90) scale(66.3949)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C822D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.711538,
    stopColor: "#170FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#190BE4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurseIcon);
export default __webpack_public_path__ + "static/media/purse-icon.53adbe849e6e81018662cd4909ed7b3d.svg";
export { ForwardRef as ReactComponent };